import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { generalService } from '../../services/general.service';
import { ItemFamily } from '../../models/item-family';
import { DataSourceGrid } from '../../utils/data-source-grid.component';
import { MatPaginator, MatSort, MatDialog } from '@angular/material';
import { DataService } from '../../utils/data.service';
import { modalComponent } from '../../utils/modal/modal.component';
import { Item } from '../../models/item';

@Component({
  selector: 'my-item-family-consult-delete',
  templateUrl: './item-family-consult-delete.component.html',
  styleUrls: [],
  providers: [generalService]
})
export class ItemFamiliaConsultDeleteComponent implements OnInit {

  public title = 'Item Familia';
  public getInactives = false;
  public disabledCheck = true;
  public family:ItemFamily;

  public dataSource: DataSourceGrid | null;
  public displayedColumns = ['acciones', 'NAME'];
  public familyList: Array<ItemFamily>;
  public numberOfRecords = 0;

  private loacs;
  public userData: any = JSON.parse(sessionStorage.getItem('user'));

  // Modal messages
  private readonly CONFIRM_DELETE_MSG = '¿Está seguro que desea eliminar la Familia?';
  private readonly DELETE_SUCCESS_MSG = 'Familia eliminado exitosamente';
  private readonly DELETE_ERROR_MSG = 'La Familia tiene activado una subfamilia';
  
  //private readonly REACTIVATE_SUCCESS_MSG = 'Producto reactivado exitosamente';

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  
  constructor(private _generalService: generalService,
              public dataService: DataService,
              public dialog: MatDialog,
              private cdr: ChangeDetectorRef) { 
                
              }

  ngOnInit() {
    this.loacs = sessionStorage.getItem("acslo");
    this.consultGrid();
  }

  confirmDeleteProduct(familyID) {
    this.dataService.modal = 'confirm';
    this.dataService.mensaje = this.CONFIRM_DELETE_MSG;

    const dialogModal = this.dialog.open(modalComponent, {disableClose: true});
    this.dataService.dialogRef = dialogModal;

    dialogModal.afterClosed()
               .subscribe(result => {
                 if (this.dataService.guardado) {
                  this.deleteProduct(familyID);
                 }
               });
  }

  deleteProduct(familyID:any) {
    var params = {
      ItemFamilyId: familyID.ITEM_FAMILY_ID,
      NAME:familyID.NAME, 
      CompanyId : familyID.COMPANY_ID
    }
    this._generalService.metodoCallParams(params, 'itemFamily/deleteItemFamily/')
        .subscribe(ok => {
          var result = JSON.parse(ok);
          if(result.length > 0){
            this._generalService.toastCall(this.DELETE_ERROR_MSG);
          }else{
            this._generalService.toastCall(this.DELETE_SUCCESS_MSG);
            this.consultGrid();
          }
          
        }, error => {
          // Custom error handler
        });
  }

  // consultProducts() {
  //   this.consult();
  // }

  // consultDisabledItems() {
  //   this.consult(true);
  // }

  // consult(disabledProducts=false) {
  //   this._generalService.metodoCallParams(this.loacs, `item/${disabledProducts? 'consultDisabledItems' : 'consultItems'}`)
  //       .finally(() => this.disabledCheck = false)
  //       .subscribe(products => {
  //         this.familyList = JSON.parse(products);
  //         this.numberOfRecords = this.familyList.length;

  //         if (this.familyList.length > 0) {
  //           this.dataSource = new DataSourceGrid(this.familyList, this.paginator, this.sort);
  //         } else {
  //           this.dataSource = undefined;
  //         }

  //       }, error => {
  //         // Custom error handler
  //       });
  // }

  consultGrid() {
    var params = {
      userID: this.userData.USER_ID,
      familyID: undefined
    }
    this._generalService.metodoCallParams(params, 'itemFamily/consultaFamily/')
        .subscribe(products => {
          this.familyList = JSON.parse(products);
          this.numberOfRecords = this.familyList.length;

          if (this.familyList.length > 0) {
            this.dataSource = new DataSourceGrid(this.familyList, this.paginator, this.sort);
          } else {
            this.dataSource = undefined;
          }

        }, error => {
          // Custom error handler
        });
  }

  // checkChange() {
  //   this.disabledCheck = true;
  //   this.cdr.detectChanges();
  //   if (this.getInactives) {
  //     this.consultDisabledItems();
  //   } else {
  //     this.consultProducts();
  //   }
  // }

  // reactivateProduct(material: Material) {
  //   this._generalService.metodoCallParams(this.loacs, `item/enable?itemId=${material.itemID}`)
  //   .subscribe(ok => {
  //     this._generalService.toastCall(this.REACTIVATE_SUCCESS_MSG);
  //     this.familyList = this.familyList.filter(item => item.itemID !== material.itemID);
      
  //     if (this.familyList.length > 0) {
  //       this.dataSource = new DataSourceGrid(this.familyList, this.paginator, this.sort);
  //     } else {
  //       this.dataSource = undefined;
  //     }

  //   }, error => {
  //     // Custom error handler
  //   });
  // }

  searchFilter(searchTerm: string) {
      if(this.familyList.length <= 0) {
        this.dataSource = undefined;
      } else {
        let filteredProducts = this.familyList;
        if(searchTerm != "") {
          filteredProducts = this.familyList.slice().filter((family: ItemFamily) => {            
            if (family.name.toLowerCase().indexOf(searchTerm.toLowerCase()) != -1)
                return true;
            else
                return false;
          });
        }
        this.dataSource = new DataSourceGrid(filteredProducts, this.paginator, this.sort);
        this.numberOfRecords = filteredProducts.length;
      }
  }

}



// WEBPACK FOOTER //
// ./src/app/familia/consult-delete/item-family-consult-delete.component.ts